import React, { type FC, useEffect, memo } from 'react';
import { Button, Dialog, DialogContent, DialogActions } from '@mui/material';
export type PrePopModalProps = {
  visible: boolean;
  hide: () => void;
  children?: React.ReactNode;
  padding?: number | string;
  paddingHorizontal?: number | string;
  paddingVertical?: number | string;
};

const PrepPopModal: FC<PrePopModalProps> = ({ visible, hide, children }) => {
  if (!visible) return null;
  return (
    <Dialog open={visible}>
      <DialogContent onClick={hide}>{children}</DialogContent>
    </Dialog>

    /*<div className="modal-backdrop" onClick={hide} >
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-btn" onClick={hide}>×</button>
        {children}
      </div>
    </div>*/
  );
};

export { PrepPopModal };
